import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { ReplaySubject } from 'rxjs';
import { BlockingTaskService } from 'src/commons/services/blockingtask/blockingTask.service';
import { EmpresaService } from 'src/commons/services/empresa/empresa.service';
import { HttpApiService } from 'src/commons/services/http/http-api.service';
import { LoggerService } from 'src/commons/services/logger.service';
import { environment } from 'src/environments/environment';
import { IClaveSaml } from './clavesaml';
import { MessageService } from 'primeng/api';

@Injectable({
  providedIn: 'root'
})
export class LoginService {

_userToken?: LoginInfo;

//Getter for the userToken
public get userToken()  {return this._userToken}

private subject = new ReplaySubject<LoginInfo|null>(1);

constructor(private  httpApi:HttpApiService,
  private log: LoggerService,
  private blockingTaskService: BlockingTaskService,
  private empresaService:EmpresaService,
  private router:Router,
  private messageSrv:MessageService
  ) {}

  /**
   *
   * REturns if the user is logged in
   */
  isLoggedIn():boolean{
    return this._userToken != null;
  }

  onLoginInfoChanged() {
    return this.subject.asObservable();
  }

  doServCertLogin():Promise<any>  {

    return new Promise((resolve, reject) => {
      this.httpApi.getApi(environment.loginCert).then((data) => {

        if(data !== undefined && data !== null && data !== "") {
        this.log.debug("data: " + data);
        this.processToken(data.userToken);
        this.processLoginInfo();

          resolve(this._userToken);
        }else{
          this.log.error("Error al obtener el token de usuario");
          this.subject.next(null);
          reject("No se ha podido  obtener el token de usuario");
        }

      }, (error) => {
        if (error.status === 401) {
          //No autorizado
          this.log.error("Usuario no autorizado");
          this.subject.next(null);
          reject("Usuario no autorizado");
        } else {
          this.log.error("Error al obtener el token de usuario");
          this.subject.next(null);
          reject("Error al obtener el token de usuario");
        }
      });
    });
  }


  private processToken(data: any) {
    const tokenInfo = JSON.parse(atob(data.split('.')[1]));

    this.log.debug("Token de usuario obtenido: " + tokenInfo);
    //map authorities to a string array
    let authorities = tokenInfo.authorities.map((element: any) => element.authority);

    this._userToken = {
      authorities: authorities,
      cif: tokenInfo.cif,
      nif: tokenInfo.sub
    };
    this.httpApi.token = data;
    this.subject.next(this._userToken);
  }


  processLoginInfo() {
    if(this.isEmpresa()){
      this.getDatosEmpresa();
    }else if(this.isAESAN() || this.isCartera() || this.isCarteraLectura()){
      this.router.navigate(['/ui/empresa/solicitudes']);
      this.log.info("Iniciando aplicación para perfil AESAN /CARTERA");
    }else if(this.isUser()){
      this.log.info("Iniciando aplicación para perfil USUARIO");
      this.router.navigate(['/ui/']);

    }else {
      this.log.info("Usuario no reconocido");

    }

  }

  isEmpresa():boolean|undefined{
    return this._userToken?.authorities.includes(ROLES.EMPRESA);
  }

  isAESAN():boolean|undefined{
    return this._userToken?.authorities.includes(ROLES.AESAN);
  }

  isCartera():boolean|undefined{
    return this._userToken?.authorities.includes(ROLES.CARTERA);
  }

  /**
   * isCarteraLectura
   *
   * @return {*}  {(boolean|undefined)}
   * @memberof LoginService
   */
  isCarteraLectura():boolean|undefined{
    return this._userToken?.authorities.includes(ROLES.CARTERA_LECTURA);
  }

  isAdmin():boolean|undefined{

    //USer is admin if has any of the following roles
    let adminRoles = [ROLES.ADM_USUARIOS,ROLES.ADM_PARAMETRIZACION];
    return this._userToken?.authorities.some(r=> adminRoles.includes(r as ROLES));
  }

  hasRole(role: ROLES): boolean {
    return this._userToken?.authorities.includes(role)!;
  }

  /**
   * DEvuelev si el usuatio no tiene ningun rol
   */
  isUser():boolean{
    return this._userToken?.authorities.length! > 0;
  }

private getDatosEmpresa(){

  this.log.info("Obteniendo datos de la empresa");
  this.blockingTaskService.runPromise(this.empresaService.loadDatosEmpresa()).then((data) => {

      this.log.debug("Datos de la empresa obtenidos");

      if (data.email == null || !this.mailValido(data.email)) {
        this.router.navigate(['/ui/empresa/perfil']);
      } else {
        this.router.navigate(['/ui/empresa']);
      }

      
  },error => {
    console.log("Login service error");

    if(error != null && error.responseCode == "404"){

      this.log.info("No se han encontrado datos de la empresa");
      this.router.navigate(['/ui/empresa/perfil']);
    }

}).catch((error) => {
    this.log.error(error);

  });
}


/**Funciones para el logado mediante clave. Primero solicitará un SAML con la petición que se enviará como un formulario oculto a la pasarela */


/**
 * Llama al endpoint para obtener el SAML
 */

getClaveSaml():Promise<IClaveSaml>  {

   return new Promise((resolve, reject) => {
      this.httpApi.getApi(environment.loginClaveGetToken).then((data:IClaveSaml) => {

        if(data !== undefined && data !== null) {
          this.log.debug("data: " + data);
          resolve(data);
        }else{
          this.log.error("Error al obtener el token SAML");
          reject(Error("No se ha podido  obtener el token SAML"));
        }

      }, (error) => {
        if (error.status === 401) {
          //No autorizado
          this.log.error("Usuario no autorizado");
          reject("Usuario no autorizado");
        } else {
          this.log.error("Error al obtener el token de usuario");
          reject("Error al obtener el token de usuario");
        }
      });
    });


}

/**
 * Lanza la obtención del token pasando la cookie de la pasarela de clave
 */

doClaveLogin():Promise<any>{

  return this.httpApi.getApi(environment.loginClave,{withCredentials:true}).then((data) => {

    if(data !== undefined && data !== null && data !== "") {
      this.log.debug("data: " + data);
      this.processClaveLogin(data.userToken);
    }else{
      this.log.error("Error al obtener el token de usuario");
      this.subject.next(null);
      this.messageSrv.add({severity:'error', summary: 'Error', detail: 'Error al obtener la información de usuario'});

    }

  });
}

/**Procesa la respuesta de un logado por pasarela clave */
processClaveLogin(data: string) {

  //Si los datos son nulos procesa el token y se muestra un mensaje de error , a continuación se redirige a la página de login

  if(data === undefined || data === null || data === "") {
    this.log.error("Error al obtener el token de usuario");
    this.subject.next(null);
    return ;
  }

  this.processToken(data);
  this.processLoginInfo();
}

mailValido(mail: string): boolean {
  const emailRegex: RegExp = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
  return emailRegex.test(mail);
}

}
export interface LoginInfo {
    authorities:string[];
    cif: string;
    nif: string
}


export enum ROLES {
  EMPRESA = "ROLE_EMPRESA",
  AESAN = "ROLE_GESTIONAR_OFERTA_AESAN",
  CARTERA = "ROLE_GESTIONAR_OFERTA_CARTERA",
  CARTERA_LECTURA = "ROLE_CARTERA_LECTURA",
  ADM_USUARIOS = "ROLE_USUARIOS",
  ADM_PARAMETRIZACION = "ROLE_PARAMETROS",
  HP_BAC = "ROLE_HP-BAC",
  NOMENCLATOR_IF = "ROLE_NOMENCLATOR_IF",
  NOMENCLATOR = "ROLE_NOMENCLATOR",
  NOMENCLATOR_IF_CANARIAS = "ROLE_NOMENCLATOR_IF_CANARIAS",
  NOMENCLATOR_IF_CCAA = "ROLE_NOMENCLATOR_IF_CCAA",
  NOMENCLATOR_IF_CEUTA = "ROLE_NOMENCLATOR_IF_CEUTA",
  NOMENCLATOR_IF_MELILLA = "ROLE_NOMENCLATOR_IF_MELILLA",
  NOMENCLATOR_IF_FEDIFAR = "ROLE_NOMENCLATOR_IF_FEDIFAR",
  NOMENCLATOR_SIN_DATOS_ECONOMICOS = "ROLE_NOMENCLATOR_SIN_DATOS_ECONOMICOS",
  NOMENCLATOR_VADEMECUM = "ROLE_NOMENCLATOR_VADEMECUM",
  CONSUMO = "ROLE_CONSUMO",
  CONSUMO_DATOS = "ROLE_CONSUMO_DATOS",
  ETIQUETADO = "ROLE_ETIQUETADO",
  DESARROLLADOR = "ROLE_DESARROLLADOR",
  AUDITOR = "ROLE_AUDITOR"
}


